import React from "react";
import { ButtonStyled } from "./ButtonStyled";
import { ButtonPropsInterface } from "../../entities/Button";

const Button: React.FC<ButtonPropsInterface> = ({
  name,
  styles,
  className,
  disabled,
  onClick,
  testid,
  bgColor,
}) => (
  <ButtonStyled
    className={className}
    width={styles?.width}
    $margin={styles?.$margin}
    disabled={disabled}
    onClick={onClick}
    style={{backgroundColor:bgColor?bgColor:'',borderColor:bgColor?bgColor:''}}
    data-testid={testid}
  >
    <span>{name}</span>
  </ButtonStyled>
);

export default Button;
